import { lazy, Suspense } from "react";
import AdminHeaders from "../component/Admin/AdminHeaders";
const AdminDash = lazy(() => import("../component/Admin/AdminDashBoard"));
const AdminSponsorDetails = lazy(() =>
  import("../component/Admin/AdminSponsorDetails.jsx")
);
const AdminEditSponsor = lazy(() =>
  import("../component/Admin/AdminEditSponsor.jsx")
);
const AdminSponsorRequest = lazy(() =>
  import("../component/Admin/sponsormanagment/AdminSponsorRequest.jsx")
);
const AdminViewRequest = lazy(() =>
  import("../component/Admin/sponsormanagment/AdminViewRequest.jsx")
);
const AdminCreateCampaign = lazy(() =>
  import("../component/Admin/sponsormanagment/AdminCreateCampaign.jsx")
);
const AdminViewCampaign = lazy(() =>
  import("../component/Admin/sponsormanagment/AdminViewCampaign.jsx")
);
const AdminEditCampaign = lazy(() =>
  import("../component/Admin/sponsormanagment/AdminEditCampaign.jsx")
);
const AdminOutgoingInvites = lazy(() =>
  import("../component/Admin/sponsormanagment/AdminOutgoingInvites.jsx")
);
const AdminTransactions = lazy(() =>
  import("../component/Admin/AdminTranscation")
);
const AdminEventCategories = lazy(() =>
  import("../component/Admin/EventCategories")
);
const EventBookingHistory = lazy(() =>
  import("../component/Admin/EventBookingHistory.jsx")
);
const MovieBookingHistory = lazy(() =>
  import("../component/Admin/MovieBookingHistory.jsx")
);
const AllAdmins = lazy(() => import("../component/Admin/AdminAllAdmins.jsx"));
const AdminDetails = lazy(() => import("../component/Admin/AdminDetails.jsx"));
const CustomerDetails = lazy(() =>
  import("../component/Admin/AdminCustomerDetails.jsx")
);
const AddAdmin = lazy(() => import("../component/Admin/AdminAddAdmin.jsx"));
const AdminEditAdmin = lazy(() =>
  import("../component/Admin/AdminEditAdmin.jsx")
);
const EditCustomer = lazy(() =>
  import("../component/Admin/AdminEditCustomer.jsx")
);
const AdminCompletedBooking = lazy(() =>
  import("../component/Admin/AdminCompletedBooking")
);
const AdminHeader = lazy(() => import("../component/Admin/AdminHeaders"));
const SidebarAdmin = lazy(() => import("../component/Admin/SideBarAdmin"));
const AdminVenueEvents = lazy(() =>
  import("../component/Admin/AdminVenueEvents")
);
const OrganizerDetails = lazy(() => import("../component/OrganizerDetails"));
const AdminOnlineEvents = lazy(() =>
  import("../component/Admin/AdminOnlineEvents")
);
const AdminMovies = lazy(() =>
  import("../component/Admin/movie-management/MovieManagement")
);
const updateMovies = lazy(() =>
  import("../component/Admin/movie-management/UpdateMovie")
);
const AddMovies = lazy(() =>
  import("../component/Admin/movie-management/AddMovie")
);
const serviceFeeOverview = lazy(() =>
  import("../pages/ServiceFeeOverview.jsx")
);

const movieHistory = lazy(() =>
  import("../component/Admin/movie-management/Moviehistory.js")
);
const theater = lazy(() =>
  import("../component/Admin/movie-management/AllotTheater.jsx")
);
const AddTheater = lazy(() =>
  import("../component/Admin/movie-management/AddTheater.jsx")
);
const AdminUpdateEvent = lazy(() => import("../component/Admin/UpdateEvent"));
const SponsorEventStats = lazy(() =>
  import("../component/Admin/SponsorEventStats")
);
const WithdrawPaymentMethods = lazy(() =>
  import("../component/Admin/WithdrawPaymentMethods")
);
const AdminRegisteredOrganizer = lazy(() =>
  import("../component/Admin/AdminRegisteredOrganizer")
);
const AdminAddOrganizer = lazy(() =>
  import("../component/Admin/AdminAddOrganizer")
);

//add sponsor
const AdminAddSponsor = lazy(() =>
  import("../component/Admin/AdminAddSponsor.jsx")
);
const sponsorDetails = lazy(() =>
  import("../component/Admin/AdminSponsorDetails.jsx")
);

const sponsorEdit = lazy(() =>
  import("../component/Admin/AdminEditSponsor.jsx")
);

const AdminRegisteredCustomer = lazy(() =>
  import("../component/Admin/AdminRegisteredCustomer")
);
const AdminAddCustomer = lazy(() =>
  import("../component/Admin/AdminAddCustomer")
);
const AdminAnnouncePopups = lazy(() =>
  import("../component/Admin/AdminAnnouncePopups")
);
const AdminSubscribers = lazy(() =>
  import("../component/Admin/AdminSubscribers")
);
const AdminMailSubscribers = lazy(() =>
  import("../component/Admin/AdminMailSubscribers")
);
const AdminInviteSubscribers = lazy(() =>
  import("../component/Admin/AdminInviteSubscribers")
);
const EventBroadcastPage = lazy(() =>
  import("../pages/broadcast/EventBroadcastPage.jsx")
);
const AdminLanguageKeyword = lazy(() =>
  import("../component/Admin/AdminLanguageKeyword")
);
const AdminLanguageManagement = lazy(() =>
  import("../component/Admin/AdminLanguageManagement")
);
const AdminPwaScannerSetting = lazy(() =>
  import("../component/Admin/AdminPwaScannerSetting")
);
const AdminTickets = lazy(() => import("../component/Admin/Tickets"));
const AddTicket = lazy(() => import("../component/AdminTickets/Tickets.jsx"));
const updateTicket = lazy(() =>
  import("../component/AdminTickets/TicketUpdate")
);
const AdminMovieTickets = lazy(() =>
  import("../component/Admin/movie-management/MovieTickets.jsx")
);
const AdminAddTheatre = lazy(() =>
  import("../component/Admin/movie-management/AddTheater.jsx")
);
const AddMovieTicket = lazy(() =>
  import("../component/AdminMovieTickets/AddTicket.jsx")
);
const updateMovieTicket = lazy(() =>
  import("../component/AdminMovieTickets/TicketUpdate")
);
const AdminOnlineGateWay = lazy(() =>
  import("../component/Admin/AdminOnlineGateWay")
);
const AdminOfflineGateway = lazy(() =>
  import("../component/Admin/AdminOfflineGateway")
);
const AdminSupportAllTickets = lazy(() =>
  import("../component/Admin/AdminSupportAllTickets")
);

const EditOrganizer = lazy(() =>
  import("../component/Admin/AdminEditOrganizer.jsx")
);
const DetailOrganizer = lazy(() =>
  import("../component/Admin/AdminOrganizerDetails.jsx")
);
const AdminSupportPendingTickets = lazy(() =>
  import("../component/Admin/AdminSupportPendingTickets")
);
const AdminSupportCloseTickets = lazy(() =>
  import("../component/Admin/AdminSupportCloseTickets")
);
const AdminSupportOpenTickets = lazy(() =>
  import("../component/Admin/AdminSupportOpenTickets")
);
const AdminBlogManagementCategories = lazy(() =>
  import("../component/Admin/AdminBlogManagementCategories")
);
const AdminBlogManagementBlogs = lazy(() =>
  import("../component/Admin/AdminBlogManagementBlogs")
);
const AdminStripeTransactions = lazy(() =>
  import("../component/Admin/Transactions.jsx")
);
const AdminCoupon = lazy(() => import("../component/Admin/AdminCoupon"));
const AdminReports = lazy(() => import("../component/Admin/AdminReports"));
const AdminTaxCommission = lazy(() =>
  import("../component/Admin/AdminTaxCommission")
);
const AdminOrganizerSettings = lazy(() =>
  import("../component/Admin/AdminOrganizerSettings")
);
const AdminSupportTicketsSettings = lazy(() =>
  import("../component/Admin/AdminSupportTicketsSettings")
);
const updateCustomer = lazy(() =>
  import("../component/Admin/AdminUpdateCustomer")
);
const AdminPushNotificationSettings = lazy(() =>
  import("../component/Admin/AdminPushNotificationSettings")
);
const AdminPushNotificationSendNoti = lazy(() =>
  import("../component/Admin/AdminPushNotificationSendNoti")
);
const AdminGeneralSettings = lazy(() =>
  import("../component/Admin/AdminGeneralSettings")
);
const AdminSettingsBreadcrumb = lazy(() =>
  import("../component/Admin/AdminSettingsBreadcrumb")
);
const AdminPageHeadingSettings = lazy(() =>
  import("../component/Admin/AdminPageHeadingSettings")
);
const AdminPluginsSettings = lazy(() =>
  import("../component/Admin/AdminPluginsSettings")
);
const AdminSettingSeoInformation = lazy(() =>
  import("../component/Admin/AdminSettingSeoInformation")
);
const AdminSettingsMaintenanceMode = lazy(() =>
  import("../component/Admin/AdminSettingsMaintenanceMode")
);
const AdminSettingCookieAlert = lazy(() =>
  import("../component/Admin/AdminsettingCookieAlert")
);
const AdminSettingsFooterLogo = lazy(() =>
  import("../component/Admin/AdminSettingsFooterlogo")
);
const AdminSocialMediaSetting = lazy(() =>
  import("../component/Admin/AdminSocialMediaSetting")
);
const AdminEmailSettMailFromAdmin = lazy(() =>
  import("../component/Admin/AdminEmailSettMailFromAdmin")
);
const AdminEmailSettMailToAdmin = lazy(() =>
  import("../component/Admin/AdminEmailSettMailToAdmin")
);
const AdminEmailSettMailTemplates = lazy(() =>
  import("../component/Admin/AdminEmailSettMailTemplates")
);
const AdminEditProfile = lazy(() =>
  import("../component/Admin/AdminEditProfile")
);
const AdminChangePassword = lazy(() =>
  import("../component/Admin/AdminChangePassword")
);
const AdminAddOnlineEvent = lazy(() =>
  import("../component/Admin/AdminAddOnlineEvent")
);
const AdminAddVenueEvent = lazy(() =>
  import("../component/Admin/AdminAddVenueEvent")
);
const AdminAddSeatEvent = lazy(() =>
  import("../component/Admin/AddSeatsEvent.jsx")
);
const AdminSelectPopUp = lazy(() =>
  import("../component/Admin/AdminSelectPopUp")
);
const EventManagementAdmin = lazy(() =>
  import("../component/Admin/EventManagementAdmin")
);
const MovieCompletedBooking = lazy(() =>
  import("../component/Admin/MovieCompleteBookings.jsx")
);
const AdminBookingDetail = lazy(() =>
  import("../component/Admin/AdminBookingDetail.jsx")
);
const AttendeeSettingsPage = lazy(() =>
  import("../pages/attendees/AttendeeSettingsPage.jsx")
);
const AdminRegisteredSponsors = lazy(() =>
  import("../component/Admin/AdminRegisteredSponsors.jsx")
);
const AdminWithdrawRequest = lazy(() =>
  import("../component/Admin/AdminWithdrawRequest")
);
const EventManageAllEvents = lazy(() =>
  import("../component/Admin/EventManageAllEvents")
);
const AdminRoleAndPermission = lazy(() =>
  import("../component/Admin/AdminRoleAndPermission.jsx")
);
const PreRegistrationManager = lazy(
  () => import("../pages/eventsmanagement/PreRegistrationManager.jsx"),
);
const AdminEditPermissions = lazy(() =>
  import("../component/Admin/AdminPermissionPage.jsx")
);
const AdminMovieGenres = lazy(() =>
  import("../component/Admin/AdminMovieGenres.jsx")
);
const AdminAddCoupon = lazy(() => import("../component/Admin/AddCoupons.jsx"));
const AdminGuestCheckout = lazy(() =>
  import("../component/Admin/AdminGuestCheckout")
);
const AddEventAdmin = lazy(() => import("../component/Admin/AddEventAdmin"));
const AdminFaq = lazy(() => import("../component/Admin/AdminFaq"));
const AdminAddBlog = lazy(() => import("../component/Admin/AdminAddBlog"));
const AdminAddHeader = lazy(() =>
  import("../component/Admin/AdminAddHeader.jsx")
);
const AdminIndex = lazy(() => import("../pages/AdminIndex.jsx"));
const AdminAuraSurveyApplicants = lazy(() =>
  import("../component/Admin/AdminAuraSurveyApplicants.jsx")
);

// camapign Managment
const Campaigns = lazy(() => import("../component/Admin/CampaignsList.jsx"));
const CampaignDetail = lazy(() =>
  import("../component/Admin/CampaignDetail.jsx")
);
const CampaignFeeRules = lazy(() =>
  import("../component/Admin/CampaignFeeRulesPanel.jsx")
);
const CampaignApplications = lazy(() =>
  import("../component/Admin/CampaignApplications.jsx")
);
const AllApplications = lazy(() =>
  import("../component/Admin/AllApplications.jsx")
);
const CampaignApplicationDetail = lazy(() =>
  import("../component/Admin/CampaignApplicationDetail.jsx")
);
const SendCampaignInvites = lazy(() =>
  import("../component/Admin/SendCampaignInvites.jsx")
);
const OutgoingInvites = lazy(() =>
  import("../component/Admin/OutgoingInvites.jsx")
);
const GlobalServiceFee = lazy(() =>
  import("../pages/GlobalServiceFeePage.jsx")
);
const AdminPayouts = lazy(() =>
  import("../component/Admin/AdminPayouts.jsx")
);
const AdminEventPayoutHistory = lazy(() =>
  import("../pages/payout/AdminEventPayoutHistory.jsx")
);
const renderRoute = (Component) => (
  <Suspense
    fallback={
      <div className="flex space-x-2 justify-center items-center bg-white h-screen dark:invert">
        <span className="sr-only">Loading...</span>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
      </div>
    }
  >
    <Component />
  </Suspense>
);

const adminNavigationRoutes = [
  {
    path: "",
    element: renderRoute(AdminIndex),
    name: "Index",
    skipPermission: true,
  },
  {
    path: "service-fee",
    element: renderRoute(serviceFeeOverview),
    name: "Service Fee",
    skipPermission: true,
  },
  {
    path: "payout-management",
    element: renderRoute(AdminPayouts),
    name: "Payout Management",
    skipPermission: true,
  },
  {
    path: "payouts/event/:type/:eventRef",
    element: renderRoute(AdminEventPayoutHistory),
    name: "Payout History",
    skipPermission: true,
  },
  {
    path: "service-fee/global",
    element: renderRoute(GlobalServiceFee),
    name: "Global Service Fee",
    skipPermission: true,
  },
  { path: "home", element: renderRoute(AdminDash), name: "DashBoard" },
  {
    path: "transcations",
    element: renderRoute(AdminTransactions),
    name: "Transactions",
  },
  {
    path: "event-management",
    element: renderRoute(EventManagementAdmin),
    name: "Event Management",
  },
  {
    path: "role-permissions",
    element: renderRoute(AdminRoleAndPermission),
    name: "Admin Management",
  },
  {
    path: "stripe-transactions",
    element: renderRoute(AdminStripeTransactions),
    name: "Admin Management",
  },
  {
    path: "role-permissions/edit-permission",
    element: renderRoute(AdminEditPermissions),
    name: "Admin Management",
  },
  {
    path: "movie-bookings",
    element: renderRoute(MovieCompletedBooking),
    name: "Movie Bookings",
  },
  {
    path: "event-management/event-categories",
    element: renderRoute(AdminEventCategories),
    name: "Event Management",
  },
  {
    path: "movie-management/add-movie",
    element: renderRoute(AddMovies),
    name: "Movie Management",
  },
  {
    path: "movie-management/all-movies",
    element: renderRoute(AdminMovies),
    name: "Movie Management",
  },
  {
    path: "movie-management/update-movie",
    element: renderRoute(updateMovies),
    name: "Movie Management",
  },
  {
    path: "movie-management/theatres",
    element: renderRoute(theater),
    name: "Movie Management",
  },
  {
    path: "movie-management/add-theatre",
    element: renderRoute(AdminAddTheatre),
    name: "Movie Management",
  },
  {
    path: "movie-management/ticket-manage/:id/:slug/:country",
    element: renderRoute(AdminMovieTickets),
    name: "Movie Management",
  },
  {
    path: "movie-management/addTicket/:id/:country",
    element: renderRoute(AddMovieTicket),
    name: "Movie Management",
  },
  {
    path: "movie-management/updateTicket/:ticket_id/:id/:country",
    element: renderRoute(updateMovieTicket),
    name: "Movie Management",
  },
  {
    path: "event-bookings",
    element: renderRoute(AdminCompletedBooking),
    name: "Event Bookings",
  },
  {
    path: "withdraw-method/payment",
    element: renderRoute(WithdrawPaymentMethods),
    name: "Withdraw Method",
  },
  {
    path: "event-booking/settings/guest-checkout",
    element: renderRoute(AdminGuestCheckout),
    name: "Event Bookings",
  },
  {
    path: "event-management/all-events",
    element: renderRoute(EventManageAllEvents),
    name: "Event Management",
  },
  {
    path: "event-management/venue-events",
    element: renderRoute(AdminVenueEvents),
    name: "Event Management",
  },
  {
    path: "event-management/ticket-manage/:type/:id/:slug/:country",
    element: renderRoute(AdminTickets),
    name: "Event Management",
  },
  {
    path: "event-management/addTicket/:type/:id/:country",
    element: renderRoute(AddTicket),
    name: "Event Management",
  },
  {
    path: "movie-management/movie-genres",
    element: renderRoute(AdminMovieGenres),
    name: "Movie Management",
  },
  {
    path: "events/bookings",
    element: renderRoute(EventBookingHistory),
    name: "Event Management",
  },
  {
    path: "movies/bookings",
    element: renderRoute(MovieBookingHistory),
    name: "Movie Management",
  },
  {
    path: "booking/detail",
    element: renderRoute(AdminBookingDetail),
    name: "Booking Detail",
    skipPermission: true,
  },
  {
    path: "attendee-settings/:contentType/:contentId",
    element: renderRoute(AttendeeSettingsPage),
    name: "Attendee Settings",
    skipPermission: true,
  },
  {
    path: "event-management/updateTicket/:ticket_id/:id/:type/:country",
    element: renderRoute(updateTicket),
    name: "Event Management",
  },
  {
    path: "event-management/online-events",
    element: renderRoute(AdminOnlineEvents),
    name: "Event Management",
  },
  {
    path: "withdraw-method/request",
    element: renderRoute(AdminWithdrawRequest),
    name: "Withdraw Method",
  },
  {
    path: "events/:eventId/preregistration",
    element: renderRoute(PreRegistrationManager),
    skipPermission: true,
  },
  {
    path: "aura-survey-applicants",
    element: renderRoute(AdminAuraSurveyApplicants),
    name: "AURA Survey Applicants",
    skipPermission: true,
  },
  {
    path: "customer-management/aura-survey",
    element: renderRoute(AdminAuraSurveyApplicants),
    name: "AURA Survey Applicants",
    skipPermission: true,
  },
  //sponsor
  {
    path: "sponsor-management/registered-sponsor",
    element: renderRoute(AdminRegisteredSponsors),
    name: "Sponsor Management",
  },
  {
    path: "sponsor-management/add-sponsor",
    element: renderRoute(AdminAddSponsor),
    name: "Sponsor Management",
  },
  {
    path: "sponsor-management/view/:sponsor_id",
    element: renderRoute(AdminSponsorDetails),
    name: "Sponsor Management",
  },
  {
    path: "sponsor-management/edit/:sponsor_id",
    element: renderRoute(AdminEditSponsor),
    name: "Sponsor Management",
  },
  {
    path: "sponsor-management/Sponsors-Requests",
    element: renderRoute(AdminSponsorRequest),
    name: "Sponsor Management",
  },
  {
    path: "sponsor-management/Sponsors-Requests",
    element: renderRoute(AdminSponsorRequest),
    name: "Sponsor Management",
  },
  {
    path: "sponsor-management/ViewRequest",
    element: renderRoute(AdminViewRequest),
    name: "Sponsor Management",
  },
  {
    path: "sponsor-management/invite-list",
    element: renderRoute(AdminOutgoingInvites),
    name: "Sponsor Management",
  },

  // { path: "sponsor-management/ViewRequest/:campaignId/:requestId", element: renderRoute(AdminViewRequest) }  /*for real data */ ,

  // organizer ---------------
  {
    path: "organizer-management/registered-organizer",
    element: renderRoute(AdminRegisteredOrganizer),
    name: "Organizer Management",
  },
  {
    path: "organizer-management/Create-campaign/:eventId",
    element: renderRoute(AdminCreateCampaign),
    name: "Organizer Management",
  },
  {
    path: "organizer-management/View-campaign/:campaignId",
    element: renderRoute(AdminViewCampaign),
    name: "Organizer Management",
  },
  {
    path: "organizer-management/Edit-campaign/:campaignId",
    element: renderRoute(AdminEditCampaign),
    name: "Organizer Management",
  },
  {
    path: "organizer-management/add-organizer",
    element: renderRoute(AdminAddOrganizer),
    name: "Organizer Management",
  },
  {
    path: "event-management/updateEvent",
    element: renderRoute(AdminUpdateEvent),
    name: "Event Management",
  },
  {
    path: "event-management/ViewEvent",
    element: renderRoute(SponsorEventStats),
    name: "Event Management",
  },
  {
    path: "event-management/add-event",
    element: renderRoute(AddEventAdmin),
    name: "Event Management",
  },
  {
    path: "customer-management/registered-customer",
    element: renderRoute(AdminRegisteredCustomer),
    name: "Customer Management",
  },
  {
    path: "customer-management/add-customer",
    element: renderRoute(AdminAddCustomer),
    name: "Customer Management",
  },
  {
    path: "customer-management/registered-customer/details",
    element: renderRoute(CustomerDetails),
    name: "Customer Management",
  },
  {
    path: "customer-management/update-customer",
    element: renderRoute(updateCustomer),
    name: "Customer Management",
  },
  { path: "faqs", element: renderRoute(AdminFaq), name: "Faqs" },
  {
    path: "announce-popups",
    element: renderRoute(AdminAnnouncePopups),
    name: "Announcement Popups",
  },
  {
    path: "headers",
    element: renderRoute(AdminHeaders),
    name: "Announcement Headers",
  },
  {
    path: "add-header",
    element: renderRoute(AdminAddHeader),
    name: "Announcement Headers",
  },
  {
    path: "organizer-management/registered-organizer/edit-organizer",
    element: renderRoute(EditOrganizer),
    name: "Organizer Management",
  },
  {
    path: "organizer-management/registered-organizer/detail",
    element: renderRoute(DetailOrganizer),
    name: "Organizer Management",
  },
  {
    path: "subscribers",
    element: renderRoute(AdminSubscribers),
    name: "Subscribers",
  },
  {
    path: "mail-to-subscribers",
    element: renderRoute(AdminMailSubscribers),
    name: "Subscribers",
  },
  {
    path: "invite-to-subscribers",
    element: renderRoute(AdminInviteSubscribers),
    name: "Subscribers",
  },
  {
    path: "broadcasts",
    element: renderRoute(EventBroadcastPage),
    name: "Broadcasts",
  },
  {
    path: "events/:eventId/broadcast",
    element: renderRoute(EventBroadcastPage),
    name: "Event Broadcast",
  },
  {
    path: "edit-language-keyword",
    element: renderRoute(AdminLanguageKeyword),
    name: "Language Management",
  },
  {
    path: "language-management",
    element: renderRoute(AdminLanguageManagement),
    name: "Language Management",
  },
  {
    path: "pwa-settings/pwa-scanner-settings",
    element: renderRoute(AdminPwaScannerSetting),
    name: "PWA Scanner",
  },
  {
    path: "payment-gateway/online-gateway",
    element: renderRoute(AdminOnlineGateWay),
    name: "Payment Gateways",
  },
  {
    path: "payment-gateway/offline-gateway",
    element: renderRoute(AdminOfflineGateway),
    name: "Payment Gateways",
  },
  {
    path: "support-tickets/all-tickets",
    element: renderRoute(AdminSupportAllTickets),
    name: "Support Ticket",
  },
  {
    path: "support-tickets/pending-tickets",
    element: renderRoute(AdminSupportPendingTickets),
    name: "Support Ticket",
  },
  {
    path: "support-tickets/open-tickets",
    element: renderRoute(AdminSupportOpenTickets),
    name: "Support Ticket",
  },
  {
    path: "support-tickets/close-tickets",
    element: renderRoute(AdminSupportCloseTickets),
    name: "Support Ticket",
  },
  {
    path: "blog-management/categories",
    element: renderRoute(AdminBlogManagementCategories),
    name: "Blog Management",
  },
  {
    path: "blog-management/add-blog",
    element: renderRoute(AdminAddBlog),
    name: "Blog Management",
  },
  {
    path: "blog-management/all-blogs",
    element: renderRoute(AdminBlogManagementBlogs),
    name: "Blog Management",
  },
  {
    path: "event-booking/settings/coupon",
    element: renderRoute(AdminCoupon),
    name: "Event Management",
  },
  {
    path: "event-booking/addCoupon",
    element: renderRoute(AdminAddCoupon),
    name: "Event Management",
  },
  {
    path: "event-booking/report",
    element: renderRoute(AdminReports),
    name: "Event Management",
  },
  {
    path: "basic-settings/tax-comission",
    element: renderRoute(AdminTaxCommission),
    name: "Event Management",
  },
  {
    path: "organizer-management/settings",
    element: renderRoute(AdminOrganizerSettings),
    name: "Organizer Management",
  },
  {
    path: "organizer-management/organizerDetails",
    element: renderRoute(OrganizerDetails),
    name: "Organizer Management",
  },
  {
    path: "support-tickets/settings",
    element: renderRoute(AdminSupportTicketsSettings),
    name: "Support Ticket",
  },
  {
    path: "push-notification/settings",
    element: renderRoute(AdminPushNotificationSettings),
    name: "Push Notification",
  },
  {
    path: "admin-management/registered-admin",
    element: renderRoute(AllAdmins),
    name: "Admin Management",
  },
  {
    path: "admin-management/registered-admin/detail",
    element: renderRoute(AdminDetails),
    name: "Admin Management",
  },
  {
    path: "admin-management/registered-admin/edit-admin",
    element: renderRoute(AdminEditAdmin),
    name: "Admin Management",
  },
  {
    path: "admin-management/add-admin",
    element: renderRoute(AddAdmin),
    name: "Admin Management",
  },
  {
    path: "push-notification/notification",
    element: renderRoute(AdminPushNotificationSendNoti),
    name: "Push Notification",
  },
  {
    path: "basic-settings/general-settings",
    element: renderRoute(AdminGeneralSettings),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/breadcrumb",
    element: renderRoute(AdminSettingsBreadcrumb),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/page-headings",
    element: renderRoute(AdminPageHeadingSettings),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/plugins",
    element: renderRoute(AdminPluginsSettings),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/seo-information",
    element: renderRoute(AdminSettingSeoInformation),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/maintenance-mode",
    element: renderRoute(AdminSettingsMaintenanceMode),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/cookie-alert",
    element: renderRoute(AdminSettingCookieAlert),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/footer-logo",
    element: renderRoute(AdminSettingsFooterLogo),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/social-media",
    element: renderRoute(AdminSocialMediaSetting),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/email-settings/mail-from-admin",
    element: renderRoute(AdminEmailSettMailFromAdmin),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/email-settings/mail-to-admin",
    element: renderRoute(AdminEmailSettMailToAdmin),
    name: "Basic Settings",
  },
  {
    path: "basic-settings/email-settings/mail-templates",
    element: renderRoute(AdminEmailSettMailTemplates),
    name: "Basic Settings",
  },
  {
    path: "profile-settings/edit-profile",
    element: renderRoute(AdminEditProfile),
    name: "Edit Profile",
    skipPermission: true,
  },
  {
    path: "profile-settings/change-password",
    element: renderRoute(AdminChangePassword),
    name: "Change Password",
    skipPermission: true,
  },
  {
    path: "event-management/add-event/online-event",
    element: renderRoute(AdminAddOnlineEvent),
    name: "Event Management",
  },
  {
    path: "event-management/add-event/venue-event",
    element: renderRoute(AdminAddVenueEvent),
    name: "Event Management",
  },
  {
    path: "event-management/add-event/seat-event",
    element: renderRoute(AdminAddSeatEvent),
    name: "Event Management",
  },
  {
    path: "announcement-popups/create-popup",
    element: renderRoute(AdminSelectPopUp),
    name: "Announcement Popups",
  },

  // campaign Mangage
  {
    path: "campaigns",
    element: renderRoute(Campaigns),
    name: "Campaign Management",
  },
  {
    path: "view-campaign/:campaignId",
    element: renderRoute(CampaignDetail),
    name: "Campaign Management",
  },
  {
    path: "campaigns/fee-rules/:campaignId",
    element: renderRoute(CampaignFeeRules),
    name: "Campaign Management",
  },
  {
    path: "campaigns/:campaignId/applications",
    element: renderRoute(CampaignApplications),
    name: "Campaign Management",
  },
  {
    path: "campaigns/all-applications",
    element: renderRoute(AllApplications),
    name: "Campaign Management",
  },
  {
    path: "campaigns/:campaignId/application/:requestId",
    element: renderRoute(CampaignApplicationDetail),
    name: "Campaign Management",
  },
  {
    path: "campaigns/invites-list",
    element: renderRoute(OutgoingInvites),
    name: "Campaign Management",
  },
  {
    path: "campaigns/:campaignId/invites",
    element: renderRoute(OutgoingInvites),
    name: "Campaign Management",
  },
  {
    path: "campaigns/:campaignId/invite",
    element: renderRoute(SendCampaignInvites),
    name: "Campaign Management",
  },
];

export default adminNavigationRoutes;
